import { getAccessToken } from "../Services/authToken";
export interface SoftBlockSlot {
  start_time: string; // "YYYY-MM-DDTHH:mm:ss"
  end_time: string;   // "YYYY-MM-DDTHH:mm:ss"
}

export interface SoftBlockPayload {
  invite_type: 'soft_block';
  requisition_id: string;
  interviewer_id: string;
  slots: SoftBlockSlot[];
}
const hostname = window.location.hostname;

export async function createInvites(emailPayload: any): Promise<void> 
{
  let baseurl = '';
  if (hostname.includes('localhost')) {
    baseurl = 'http://localhost:8080';
  } else if (hostname.includes('dev')) {
    baseurl= 'https://candidateinterviewscheduler-dev.pwc.com';
  } else if (hostname.includes('stg') || hostname.includes('stage')) {
    baseurl = 'https://candidateinterviewscheduler-stg.pwc.com';
  } else {
    baseurl = 'https://candidateinterviewscheduler.pwc.com'; // fallback production
  }

  // GET TOKEN
  const token = await getAccessToken();
  if (!token) {
    throw new Error('Authentication required - please log in');
  }

  console.log(emailPayload)
    // console.log(payload.requisition_id,payload.interviewer_id,payload.slots);
    const res = await fetch(`${baseurl}/api/communications/emails`, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json','Authorization': `Bearer ${token}` },
        body: JSON.stringify(emailPayload),
    });
    console.log(res);
    if (!res.ok) {
        const text = await res.text().catch(() => '');
        throw new Error(`Invite failed: ${res.status} ${res.statusText} ${text}`);
    }
}

export async function createInvitesForInterviewers(
  emailPayload: any
): Promise<void> {
  console.log(emailPayload);
  // const uniqueIds = Array.from(new Set(interviewerIds.filter(Boolean)));
  // for (const interviewer_id of uniqueIds) {
    // console.log(requisitionId,interviewerIds,startTime,endTime);
    await createInvites(
      // invite_type: 'soft_block',
      // requisition_id: requisitionId,
      // interviewer_id,
      // slots: [{ start_time: startTime, end_time: endTime }]
      emailPayload
    );
  }

